import { useState } from "react";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const InviteBadge = ({ url, testId }) => {
  const [busy, setBusy] = useState(false);
  const resend = async () => {
    setBusy(true);
    try {
      await api.post(url);
      toast.success("Invitasjonen er sendt på nytt");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-[11px] px-1.5 py-0.5 rounded font-medium bg-amber-100 text-amber-800" data-testid={`${testId}-pending`}>Venter på at invitasjonen godtas</span>
      <button type="button" onClick={resend} disabled={busy} className="inline-flex items-center gap-1 text-xs text-sky-700 hover:underline disabled:opacity-50" data-testid={`${testId}-resend`}>
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Send className="w-3.5 h-3.5" />}Send invitasjon på nytt
      </button>
    </div>
  );
};
